<template>
  <div
    class="custom-checkbox"
    :class="{ 'custom-checkbox-checked': checked }"
  >
    <div
      class="custom-checkbox-inner"
      :class="{ 'custom-checkbox-inner-checked': checked }"
    >
      <v-icon v-if="checked" class="check-icon" icon="mdi-check" />
    </div>
  </div>
</template>

<script setup>
// INFO: Virtual scroll package does not work well with input, img, link (a) tags.
defineProps({
  checked: {
    type: Boolean,
    default: false,
  },
})
</script>

<style scoped>
.custom-checkbox {
  display: inline-flex;
  align-items: center;
  justify-content: center;
  width: 20px !important;
  height: 20px !important;
  border: 2px solid rgb(var(--v-theme-primary));
  border-radius: 4px;
  cursor: pointer;
  background: rgb(var(--v-theme-neutral0));
}

.v-theme--light .custom-checkbox {
  border-color: black;
}

.v-theme--dark .custom-checkbox {
  border-color: white;
}

.custom-checkbox-inner {
  display: flex;
  align-items: center;
  justify-content: center;
  border-radius: 4px;
  width: 20px !important;
  height: 20px !important;
  width: 100%;
  height: 100%;
}

.custom-checkbox-inner-checked {
  background-color: rgb(var(--v-theme-teal600));
  border-color: rgb(var(--v-theme-teal600));
}
.custom-checkbox-checked {
  border-color: rgb(var(--v-theme-teal600)) !important;
}

.v-icon {
  font-size: 20px;
}

.v-theme--light .check-icon {
  color: white !important;
}

.v-theme--dark .check-icon {
  color: black !important;
}
</style>
